var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0778 37.6846V40.6846H11.3086V37.6846H13.5267H38.0778Z",
    fill: "#545B66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0778 19.9825L38.0907 19.9502L37.9551 19.8967L25.7019 15.7257L24.7292 15.3745L24.6998 15.3846L24.6702 15.3745L23.6976 15.7257L11.4443 19.8967L11.3086 19.9502L11.3215 19.9825V20.1932L11.3086 20.1976V37.7997H38.0907V20.1976L38.0778 20.1932V19.9825Z",
    fill: "#757D8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0775 5.95361C42.4797 5.95361 43.616 7.08992 43.616 8.49207C43.616 9.89423 42.4797 11.0305 41.0775 11.0305C39.6763 11.0305 38.5391 9.89423 38.5391 8.49207C38.5391 7.08992 39.6763 5.95361 41.0775 5.95361Z",
    fill: "#07CC66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4225 22.5688H38.0763H28.7302C28.0296 22.5688 27.4609 23.1375 27.4609 23.8381V37.7996V39.2996C27.4609 40.0002 28.0296 40.5688 28.7302 40.5688H40.9379H41.4225C42.124 40.5688 42.6917 40.0002 42.6917 39.2996V23.8381C42.6917 23.1375 42.124 22.5688 41.4225 22.5688Z",
    fill: "#313A52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9386 40.5688V43.8919H8.63086V40.5688H11.3078H28.3847H28.7309H40.9386Z",
    fill: "#3F4751"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33.646H40.8462V38.7229H39V33.646Z",
    fill: "#07CC66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30.415H40.8462V32.2612H39V30.415Z",
    fill: "#FD6814"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8465 24.415V27.6458H35.7695L38.0772 24.415H40.8465Z",
    fill: "#BDE1FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0763 24.415L35.7686 27.6458H33.4609L35.7686 24.415H38.0763Z",
    fill: "#A1D4FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7695 36.877H37.6157V38.7231H35.7695V36.877Z",
    fill: "#757D8C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7695 33.646H37.6157V35.4922H35.7695V33.646Z",
    fill: "#757D8C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7695 30.415H37.6157V32.2612H35.7695V30.415Z",
    fill: "#757D8C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7701 24.415L33.4624 27.6458H29.3086V24.415H35.7701Z",
    fill: "#BDE1FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6161 6.41504C34.9992 6.41504 35.3084 6.72519 35.3084 7.10735C35.3084 7.4895 34.9992 7.79965 34.6161 7.79965C34.234 7.79965 33.9238 7.4895 33.9238 7.10735C33.9238 6.72519 34.234 6.41504 34.6161 6.41504Z",
    fill: "#FC974D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5391 36.8765H34.3852V38.7226H32.5391V36.8765Z",
    fill: "#757D8C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5391 33.646H34.3852V35.4922H32.5391V33.646Z",
    fill: "#757D8C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5391 30.415H34.3852V32.2612H32.5391V30.415Z",
    fill: "#757D8C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3086 36.8765H31.1547V38.7226H29.3086V36.8765Z",
    fill: "#757D8C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3086 33.646H31.1547V35.4922H29.3086V33.646Z",
    fill: "#757D8C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3086 30.415H31.1547V32.2612H29.3086V30.415Z",
    fill: "#757D8C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6152 24.415H25.1537V29.0304H13.6152V24.415Z",
    fill: "#BDE1FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6161 3.646C22.9992 3.646 23.3084 3.95615 23.3084 4.3383C23.3084 4.72046 22.9992 5.03061 22.6161 5.03061C22.234 5.03061 21.9238 4.72046 21.9238 4.3383C21.9238 3.95615 22.234 3.646 22.6161 3.646Z",
    fill: "#FC974D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2309 6.41504C13.2509 6.41504 14.0771 7.24119 14.0771 8.26119C14.0771 9.28119 13.2509 10.1073 12.2309 10.1073C11.2118 10.1073 10.3848 9.28119 10.3848 8.26119C10.3848 7.24119 11.2118 6.41504 12.2309 6.41504Z",
    fill: "#07CC66"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23137 26.7231C9.61445 26.7231 9.92368 27.0333 9.92368 27.4155C9.92368 27.7976 9.61445 28.1078 9.23137 28.1078C8.84922 28.1078 8.53906 27.7976 8.53906 27.4155C8.53906 27.0333 8.84922 26.7231 9.23137 26.7231Z",
    fill: "#FC974D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69186 31.7998C7.71186 31.7998 8.53801 32.626 8.53801 33.646C8.53801 34.666 7.71186 35.4921 6.69186 35.4921C5.67278 35.4921 4.8457 34.666 4.8457 33.646C4.8457 32.626 5.67278 31.7998 6.69186 31.7998Z",
    fill: "#07CC66"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07707 14.2612C5.46015 14.2612 5.76938 14.5714 5.76938 14.9535C5.76938 15.3357 5.46015 15.6458 5.07707 15.6458C4.69492 15.6458 4.38477 15.3357 4.38477 14.9535C4.38477 14.5714 4.69492 14.2612 5.07707 14.2612Z",
    fill: "#FC974D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7838 44.3537H6.7838C6.52894 44.3537 6.32227 44.1472 6.32227 43.8922C6.32227 43.6372 6.52894 43.4307 6.7838 43.4307H42.7838C43.0388 43.4307 43.2453 43.6372 43.2453 43.8922C43.2453 44.1472 43.0388 44.3537 42.7838 44.3537Z",
    fill: "#232B3F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2303 29.4919H29.3072C29.0524 29.4919 28.8457 29.2853 28.8457 29.0304C28.8457 28.7754 29.0524 28.5688 29.3072 28.5688H30.2303C30.4853 28.5688 30.6919 28.7754 30.6919 29.0304C30.6919 29.2853 30.4853 29.4919 30.2303 29.4919Z",
    fill: "#FFD400"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5389 29.4919H31.6158C31.361 29.4919 31.1543 29.2853 31.1543 29.0304C31.1543 28.7754 31.361 28.5688 31.6158 28.5688H32.5389C32.7939 28.5688 33.0005 28.7754 33.0005 29.0304C33.0005 29.2853 32.7939 29.4919 32.5389 29.4919Z",
    fill: "#26C6DA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8456 29.4919H33.9225C33.6676 29.4919 33.4609 29.2853 33.4609 29.0304C33.4609 28.7754 33.6676 28.5688 33.9225 28.5688H34.8456C35.1005 28.5688 35.3071 28.7754 35.3071 29.0304C35.3071 29.2853 35.1005 29.4919 34.8456 29.4919Z",
    fill: "#FFCCBD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06269 21.1465C7.83223 21.5647 6.55469 20.6509 6.55469 19.3512V19.2062C6.55469 18.4567 6.99592 17.7782 7.68084 17.4736C8.13361 17.2724 7.52503 17.5427 24.6701 9.92285L41.6593 17.4736C42.3442 17.7782 42.7855 18.4567 42.7855 19.2062C42.7855 20.5456 41.435 21.4632 40.1898 20.9684C36.1632 19.3702 31.5756 17.9557 24.6701 15.5592C24.5491 15.6028 9.93176 20.8355 9.06269 21.1465Z",
    fill: "#C73B10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFund);
export default __webpack_public_path__ + "static/media/fund.f3871b4c4032e217e5789b2680818fd5.svg";
export { ForwardRef as ReactComponent };